export default "__VITE_ASSET__CFUMo4kF__"